// Get the values of the keys in the object
// TODO: remove (deprecated)
const values = obj => {
  return Object.values(obj)
}

export default values
